<template>
  <modal size="lg" content-class="bg-gray-200" @close="onClose">
    <template #header>
      <div class="w-100 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center" style="gap: 8px">
          <span v-if="data != null" class="font-weight-bold">
            Account #{{ data.user.member_number }}
            <span class="text-muted font-weight-normal ml-1">({{ data.total_nominations }})</span>
          </span>
          <span v-else class="font-weight-bold">Account detail</span>
          <router-link v-if="profileRoute != null" :to="profileRoute" target="_blank" class="icon-btn icon-btn--view" title="View profile" />
        </div>
        <div v-if="data != null && hasInvoices" class="nom-detail-popup__invoice-block">
          <app-button
            variant="primary"
            :block="false"
            size="sm"
            class="nom-detail-popup__btn"
            :loading="resending"
            :disabled="resending"
            @click="resendInvoice"
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right:5px;vertical-align:middle"><path d="M17.7158 9.37948V2.22974C17.7158 1.91365 17.4561 1.65869 17.1448 1.65869H1.07929C0.766467 1.65869 0.50824 1.91494 0.50824 2.22974V12.5086C0.50824 12.824 0.763917 13.0796 1.07929 13.0796H9.75304C9.73222 13.2672 9.72114 13.4577 9.72114 13.6507C9.72114 16.4846 12.0267 18.7901 14.8606 18.7901C17.6944 18.7901 20 16.4846 20 13.6507C20 11.8725 19.0922 10.3026 17.7158 9.37948ZM15.3628 2.80079L9.14853 7.23958L2.87504 2.80079H15.3628ZM1.65033 11.9375V3.33331L8.82026 8.40638C8.91908 8.47631 9.03459 8.51126 9.15009 8.51126C9.26643 8.51126 9.38274 8.47578 9.48202 8.40489L16.5737 3.3394V8.80524C16.0376 8.61512 15.461 8.51126 14.8606 8.51126C12.6271 8.51126 10.7222 9.94345 10.0151 11.9375H1.65033ZM14.8606 17.648C12.6564 17.648 10.8632 15.8548 10.8632 13.6507C10.8632 11.4466 12.6564 9.65336 14.8606 9.65336C17.0647 9.65336 18.8579 11.4466 18.8579 13.6507C18.8579 15.8548 17.0647 17.648 14.8606 17.648Z" fill="white"/><path d="M17.9045 12.8131C17.7629 12.6536 17.5157 12.6363 17.3524 12.7744L17.0739 13.0097C16.8399 11.8652 15.8023 11 14.5612 11C13.149 11 12 12.1212 12 13.4995C12 14.8783 13.149 16 14.5612 16C15.0657 16 15.5528 15.8575 15.9699 15.5879C16.1501 15.4714 16.1995 15.2344 16.0801 15.0586C15.9607 14.8827 15.7178 14.8346 15.5377 14.9511C15.2491 15.1376 14.9115 15.2361 14.5612 15.2361C13.5806 15.2361 12.7828 14.4571 12.7828 13.4995C12.7828 12.5425 13.5806 11.7639 14.5612 11.7639C15.3765 11.7639 16.0651 12.3016 16.2748 13.0324L15.9862 12.8214C15.8131 12.6949 15.5679 12.7292 15.4383 12.8981C15.3087 13.0669 15.3439 13.3063 15.5169 13.4328L16.472 14.1311C16.5417 14.182 16.6243 14.2073 16.7066 14.2073C16.7982 14.2073 16.8896 14.176 16.9629 14.1141L17.8648 13.352C18.0282 13.2138 18.046 12.9726 17.9045 12.8131Z" fill="white"/></svg>
            <small>RESEND INVOICE</small>
          </app-button>
          <template v-for="inv in data.invoices">
            <a
              v-if="inv.pdf_path"
              :key="inv.id"
              :href="inv.pdf_path"
              target="_blank"
              rel="noopener"
              class="nom-detail-popup__download-link"
              :title="'Download invoice #' + inv.invoice_number"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.00001 10.1333C7.89335 10.1333 7.68001 10.1333 7.57335 10.0267L4.37335 6.82668C4.16002 6.61335 4.16002 6.29335 4.37335 6.08001C4.58668 5.86668 4.90668 5.86668 5.12002 6.08001L7.89335 8.85335L10.6667 6.08001C10.88 5.86668 11.2 5.86668 11.4133 6.08001C11.6267 6.29335 11.6267 6.61335 11.4133 6.82668L8.21335 10.0267C8.32001 10.1333 8.10668 10.1333 8.00001 10.1333Z" fill="currentColor"/><path d="M8.00001 9.6C7.68001 9.6 7.46667 9.38667 7.46667 9.06667V0.533333C7.46667 0.213333 7.68001 0 8.00001 0C8.32001 0 8.53334 0.213333 8.53334 0.533333V9.06667C8.53334 9.38667 8.32001 9.6 8.00001 9.6Z" fill="currentColor"/><path d="M13.3333 16H2.66667C1.17333 16 0 14.8267 0 13.3333V11.2C0 10.88 0.213333 10.6667 0.533333 10.6667C0.853333 10.6667 1.06667 10.88 1.06667 11.2V13.3333C1.06667 14.1867 1.81333 14.9333 2.66667 14.9333H13.3333C14.1867 14.9333 14.9333 14.1867 14.9333 13.3333V11.2C14.9333 10.88 15.1467 10.6667 15.4667 10.6667C15.7867 10.6667 16 10.88 16 11.2V13.3333C16 14.8267 14.8267 16 13.3333 16Z" fill="currentColor"/></svg>
            </a>
            <a
              v-else
              :key="inv.id + '-gen'"
              href="#"
              :class="['nom-detail-popup__download-link', { 'nom-detail-popup__download-link--loading': generatingPdfIds.has(inv.id) }]"
              :title="'Download invoice #' + inv.invoice_number"
              @click.prevent="generateInvoicePdf(inv)"
            >
              <span v-if="generatingPdfIds.has(inv.id)" class="nom-detail-popup__spinner" />
              <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="opacity:0.4"><path d="M8.00001 10.1333C7.89335 10.1333 7.68001 10.1333 7.57335 10.0267L4.37335 6.82668C4.16002 6.61335 4.16002 6.29335 4.37335 6.08001C4.58668 5.86668 4.90668 5.86668 5.12002 6.08001L7.89335 8.85335L10.6667 6.08001C10.88 5.86668 11.2 5.86668 11.4133 6.08001C11.6267 6.29335 11.6267 6.61335 11.4133 6.82668L8.21335 10.0267C8.32001 10.1333 8.10668 10.1333 8.00001 10.1333Z" fill="currentColor"/><path d="M8.00001 9.6C7.68001 9.6 7.46667 9.38667 7.46667 9.06667V0.533333C7.46667 0.213333 7.68001 0 8.00001 0C8.32001 0 8.53334 0.213333 8.53334 0.533333V9.06667C8.53334 9.38667 8.32001 9.6 8.00001 9.6Z" fill="currentColor"/><path d="M13.3333 16H2.66667C1.17333 16 0 14.8267 0 13.3333V11.2C0 10.88 0.213333 10.6667 0.533333 10.6667C0.853333 10.6667 1.06667 10.88 1.06667 11.2V13.3333C1.06667 14.1867 1.81333 14.9333 2.66667 14.9333H13.3333C14.1867 14.9333 14.9333 14.1867 14.9333 13.3333V11.2C14.9333 10.88 15.1467 10.6667 15.4667 10.6667C15.7867 10.6667 16 10.88 16 11.2V13.3333C16 14.8267 14.8267 16 13.3333 16Z" fill="currentColor"/></svg>
            </a>
          </template>
        </div>
      </div>
    </template>

    <template #body>
      <div v-if="loading && data == null" class="text-center py-4">
        <div class="spinner-border text-primary" role="status" />
      </div>

      <div v-else-if="data != null" class="nom-detail-popup">
        <div v-if="loading" class="nom-detail-popup__overlay">
          <div class="spinner-border text-primary" role="status" />
        </div>

        <form-alert :message="alert.message.value" :type="alert.type.value" class="mb-3" />

        <div v-if="data.tags && data.tags.length" class="mb-3">
          <span
            v-for="tag in data.tags"
            :key="tag.id"
            class="badge alert-success mr-2"
            style="text-transform: inherit; font-size: 12px;"
          >
            {{ tag.name }}
          </span>
        </div>

        <div class="nom-detail-popup__toolbar mb-3">
          <div class="custom-control custom-checkbox">
            <input
              id="nom-select-all"
              type="checkbox"
              class="custom-control-input"
              :checked="allSelected"
              :indeterminate.prop="someSelected"
              @change="toggleSelectAll"
            />
            <label class="custom-control-label mb-0 h6 text-dark" for="nom-select-all">Select all</label>
          </div>
          <app-button
            variant="primary"
            :block="false"
            size="sm"
            class="nom-detail-popup__btn"
            :disabled="!data.draw_is_published"
            :title="!data.draw_is_published ? 'Draw is not published yet' : undefined"
            @click="$emit('resend-draw', data.user.id)"
          >
            <small>Resend draw notifications</small>
          </app-button>
        </div>
        
        <div
          v-for="(member, mi) in data.members"
          :key="member.id"
          class="nom-detail-popup__member"
        >
          <div
            class="nom-detail-popup__member-header nom-detail-popup__member-header--toggle"
            @click="toggleMember(member.id, member.events)"
          >
            <div class="custom-control custom-checkbox mr-2" @click.stop>
              <input
                :id="'nom-member-check-' + member.id"
                type="checkbox"
                class="custom-control-input"
                :checked="selectedMemberIds.indexOf(member.id) !== -1"
                @change="toggleSelectMember(member.id)"
              />
              <label class="custom-control-label mb-0" :for="'nom-member-check-' + member.id" />
            </div>
            <div class="d-flex align-items-center flex-wrap" style="gap: 8px">
              <span class="nom-detail-popup__member-name">
                {{ member.full_name }}
                <small v-if="member.deleted" class="text-primary ml-1">(deleted)</small>
                <span class="text-muted font-weight-normal">({{ member.nominations_count }})</span>
                <i class="nom-detail-popup__chevron" :class="{ 'nom-detail-popup__chevron--open': openMemberId === member.id }" />
              </span>
              <div v-if="member.is_young || member.is_old" class="d-flex align-items-center" style="gap: 5px">
                <i class="nom-red-person-icon" />
                <small class="badge alert-danger" style="text-transform: inherit; font-size: 12px;">
                  The competitor will be too {{ member.is_young ? 'young' : 'old' }} on date of campdraft
                </small>
              </div>
            </div>
          </div>
          
          <small v-if="member.needs_to_be_processed" class="badge alert-warning" style="text-transform: inherit; font-size: 12px;">
            Some nominations needs to be processed
          </small> 

          <div v-if="openMemberId === member.id">
            <div
              v-for="(event, ei) in member.events"
              :key="event.id"
              class="nom-detail-popup__event"
            >
              <div
                class="nom-detail-popup__event-header nom-detail-popup__event-header--toggle"
                @click="toggleEvent(event.id)"
              >
                <span>{{ event.name }} <span class="text-muted">({{ event.nominations_count }})</span><i class="nom-detail-popup__chevron nom-detail-popup__chevron--sm" :class="{ 'nom-detail-popup__chevron--open': openEventId === event.id }" /></span>
              </div>

            <grid-table
              v-if="openEventId === event.id"
              :rows="event.nominations"
              :columns="columnsForEvent(event)"
              :hide-header="true"
              :no-borders="true"
              :no-stripes="true"
              :draggable="true"
              border-color="white"
              border-width="2px"
              row-bg="var(--gray-200)"
              @drag-start="onDragStart($event)"
              @drag-end="onDragEnd($event, event.id)"
            >
              <template #cell:drag>
                <span class="gt__drag-handle icon-btn icon-btn--drag" title="Drag to reorder" />
              </template>

              <template #cell:draw_order="{ row }">
                <span v-if="row.draw_order != null" class="nom-detail-popup__order">{{ row.draw_order }}</span>
              </template>

              <template #cell:ntbp="{ row }">
                <i
                  v-if="row.needs_to_be_processed"
                  class="nomination_need_to_be_processed"
                  title="The user has unprocessed nominations after the draft rules has changed."
                />
              </template>

              <template #cell:horse="{ row }">
                <div class="d-flex flex-column align-items-start" style="gap: 2px">
                  <div class="d-flex align-items-center" style="gap: 6px">
                    <i class="nom-horse-icon" :class="{ 'nom-horse-icon--crossed': !event.requires_horse }" />
                    <span class="nom-detail-popup__horse-name">{{ event.requires_horse ? row.horse.name : '—' }}</span>
                    <small v-if="event.requires_horse && row.horse.deleted" class="text-primary">(deleted)</small>
                  </div>
                  <small v-if="row.comb_nomination_id != null" class="text-primary">(Combined)</small>
                </div>
              </template>

              <template #cell:owner="{ row }">
                <div v-if="!event.requires_horse" class="font-weight-bold" @click.stop>
                  <small class="d-block font-weight-bold">Quantity</small>
                  <input
                    type="number"
                    min="1"
                    :max="quantityMaxByNomId[row.id]"
                    :disabled="quantityUpdatingIds.indexOf(row.id) !== -1"
                    class="form-control nom-detail-popup__quantity-input"
                    :value="quantityOverrides[row.id] != null ? quantityOverrides[row.id] : row.quantity"
                    @change="onQuantityChange(row.id, $event.target.value, event.id)"
                  />
                </div>
                <div v-else class="font-weight-bold">
                  <small class="d-block font-weight-bold">Horse owner</small>
                  {{ row.horse.owner_name != null ? row.horse.owner_name : '—' }}
                </div>
              </template>

              <template #cell:status="{ row }">
                <div>
                  <small class="d-block font-weight-bold">Nomination Status</small>
                  <nomination-list-select :value="row.list" size-class="multiselect--sm" @input="onListChange(row, $event)" />
                </div>
              </template>

              <template v-if="event.move_to_event != null" #cell:move="{ row }">
                <div>
                  <small class="d-block font-weight-bold">Move to</small>
                  <a class="nom-detail-popup__move-link" @click="onMoveToEvent(row, event.move_to_event.id)">
                    {{ event.move_to_event.name }}
                  </a>
                </div>
              </template>

              <template #cell:scratch="{ row }">
                <i
                  v-if="row.is_scratched_by_user"
                  class="nom-scratched-icon"
                  title="The user scratched the nomination"
                />
              </template>
            </grid-table>
            </div>
          </div>
        </div>

        <confirm-modal
          v-if="pendingListChange != null"
          @confirm="confirmPendingListChange"
          @cancel="pendingListChange = null"
        >
          <template v-if="pendingListChange.warning === 'draw'">
            <p>{{ closedDrawWarning }}</p>
            <p>To do this go to the <router-link :to="{ name: 'DrawsDashboard' }">Draws page</router-link>.</p>
            <p class="mb-0">Proceed anyway?</p>
          </template>
          <p v-else class="mb-0">{{ acceptInvoiceWarning }}</p>
        </confirm-modal>
      </div>
    </template>

  </modal>
</template>

<script>
import { defineComponent, ref, watch, computed } from '@vue/composition-api'
import Modal from '@/components/Modal'
import AppButton from '@/components/AppButton'
import GridTable from '@/components/GridTable'
import FormAlert from '@/components/FormAlert'
import ConfirmModal from '@/components/ConfirmModal'
import useNominationAccountDetail from '@/composables/nominations/useNominationAccountDetail'
import useFormAlert from '@/composables/useFormAlert'
import nominationsApi from '@/services/api/nominations'
import invoicesApi from '@/services/api/invoices'
import { ACCEPT_INVOICE_WARNING, CLOSED_DRAW_WARNING, moveWarningType } from '@/utils/nominationMove'
import NominationListSelect from './NominationListSelect'

const BASE_COLUMNS = [
  { key: 'draw_order', width: '36px' },
  { key: 'drag', width: '36px' },
  { key: 'horse', width: '1fr', minWidth: '120px' },
  { key: 'owner', width: '1fr', minWidth: '100px' },
  { key: 'status', width: 'auto' },
  { key: 'scratch', width: '30px' }
]

const NTBP_COLUMN = { key: 'ntbp', width: 'auto' }
const MOVE_COLUMN = { key: 'move', width: 'auto' }

function columnsForEvent(event) {
  const hasNtbp = event.nominations.some(n => n.needs_to_be_processed)
  const hasMoveTarget = event.move_to_event != null
  let cols = BASE_COLUMNS
  if (hasNtbp) cols = [cols[0], cols[1], NTBP_COLUMN, ...cols.slice(2)]
  if (hasMoveTarget) cols = [...cols, MOVE_COLUMN]
  return cols
}

export default defineComponent({
  name: 'NominationAccountDetailPopup',
  components: { Modal, AppButton, GridTable, FormAlert, ConfirmModal, NominationListSelect },
  props: {
    draftId: { type: [String, Number], required: true },
    userId: { type: Number, required: true },
    list: { type: String, required: true },
    eventId: { type: Number, default: null },
    draftStateId: { type: Number, default: null },
    drawExists: { type: Boolean, default: false },
    onChanged: { type: Function, default: null }
  },
  emits: ['close', 'resend-draw'],
  setup(props, { emit }) {
    const { data, loading, fetch } = useNominationAccountDetail()
    const alert = useFormAlert()

    const profileRoute = computed(() => {
      if (data.value == null) return null
      return { name: 'Member Profile', params: { slug: data.value.user.id } }
    })

    const openMemberId = ref(null)
    const openEventId = ref(null)
    const selectedMemberIds = ref([])

    const allSelected = computed(() => {
      if (data.value == null || data.value.members.length === 0) return false
      return selectedMemberIds.value.length === data.value.members.length
    })

    const someSelected = computed(() => selectedMemberIds.value.length > 0 && !allSelected.value)

    function toggleSelectMember(id) {
      const idx = selectedMemberIds.value.indexOf(id)
      if (idx === -1) {
        selectedMemberIds.value = selectedMemberIds.value.concat(id)
      } else {
        selectedMemberIds.value = selectedMemberIds.value.filter(x => x !== id)
      }
    }

    function toggleSelectAll() {
      if (allSelected.value) {
        selectedMemberIds.value = []
      } else {
        selectedMemberIds.value = data.value.members.map(m => m.id)
      }
    }

    // Auto-open the first member/event only when nothing is open yet — on the initial load for
    // this target (see the props watcher below, which clears openMemberId before fetching). A
    // background refetch of the *same* target (e.g. after editing a quantity inline) must not
    // collapse whatever the secretary currently has expanded, so it's skipped once something is open.
    watch(data, (val) => {
      if (val != null && openMemberId.value == null && val.members.length > 0) {
        const first = val.members[0]
        openMemberId.value = first.id
        openEventId.value = first.events.length > 0 ? first.events[0].id : null
      }
    })

    function toggleMember(memberId, events) {
      if (openMemberId.value === memberId) {
        openMemberId.value = null
        openEventId.value = null
      } else {
        openMemberId.value = memberId
        openEventId.value = events.length > 0 ? events[0].id : null
      }
    }

    function toggleEvent(eventId) {
      openEventId.value = openEventId.value === eventId ? null : eventId
    }

    function buildParams() {
      const params = { user_id: props.userId, list: props.list }
      if (props.eventId != null) params.event_id = props.eventId
      return params
    }

    watch(
      () => [props.draftId, props.userId, props.list, props.eventId],
      () => {
        selectedMemberIds.value = []
        openMemberId.value = null
        openEventId.value = null
        fetch(props.draftId, buildParams())
      },
      { immediate: true }
    )

    function extractMsg(err, fallback) {
      return err != null && err.response != null && err.response.data != null
        ? err.response.data.message
        : fallback
    }

    // Monolith parity: moving a nom to accepted requires confirmation when the
    // draft is in Finalise (invoices are sent immediately) or Closed with
    // generated draws (the nomination will not be added to the draw).
    const pendingListChange = ref(null)

    async function doListChange(nom, list) {
      try {
        const res = await nominationsApi.bulkMove({ nomination_ids: [nom.id], list })
        if (props.onChanged != null) props.onChanged()
        alert.showSuccess(res != null && res.data != null ? res.data.message : null)
      } catch (err) {
        alert.showError(extractMsg(err, 'Failed to update status'))
        return
      }
      fetch(props.draftId, buildParams())
    }

    async function onListChange(nom, list) {
      const warning = moveWarningType(nom.list, list, props.draftStateId, props.drawExists)
      if (warning != null) {
        pendingListChange.value = { nom, list, warning }
        return
      }
      await doListChange(nom, list)
    }

    async function confirmPendingListChange() {
      const pending = pendingListChange.value
      pendingListChange.value = null
      if (pending == null) return
      await doListChange(pending.nom, pending.list)
    }

    let dragOriginalIds = []

    function onDragStart(ids) {
      dragOriginalIds = ids.slice()
    }

    function applyDrawOrders(items) {
      if (data.value == null || items == null) return

      const drawOrderByNominationId = items.reduce((result, item) => {
        result[item.nomination_id] = item.draw_order
        return result
      }, {})
      data.value.members.forEach((member) => {
        member.events.forEach((event) => {
          event.nominations.forEach((nomination) => {
            if (drawOrderByNominationId[nomination.id] != null) {
              nomination.draw_order = drawOrderByNominationId[nomination.id]
            }
          })
        })
      })
    }

    async function onDragEnd(ids, eventId) {
      if (ids.join(',') === dragOriginalIds.join(',')) return
      const items = ids.map((id, i) => ({ id, order: i + 1 }))
      try {
        const res = await nominationsApi.reorderRuns(props.draftId, eventId, { items })
        applyDrawOrders(res != null && res.data != null && res.data.data != null ? res.data.data.items : null)
        if (props.onChanged != null) props.onChanged()
        alert.showSuccess(res != null && res.data != null ? res.data.message : null)
      } catch (err) {
        fetch(props.draftId, buildParams())
        alert.showError(extractMsg(err, 'Reorder failed'))
      }
    }

    async function onMoveToEvent(nom, targetEventId) {
      try {
        const res = await nominationsApi.moveToEvent(nom.id, targetEventId)
        if (props.onChanged != null) props.onChanged()
        alert.showSuccess(res != null && res.data != null ? res.data.message : null)
      } catch (err) {
        alert.showError(extractMsg(err, 'Failed to move nomination'))
      }
      fetch(props.draftId, buildParams())
    }

    // Per-member remaining Quantity quota for a no-horse event, keyed by nomination id — mirrors
    // the backend's per-person max_submissions check (this member's other quantities in the same
    // event, capped at event.max_submissions). Same pattern as NominationsAddList.vue.
    const quantityMaxByNomId = computed(() => {
      const result = {}
      if (data.value == null) return result
      data.value.members.forEach((member) => {
        member.events.forEach((event) => {
          if (event.max_submissions == null) return
          const total = event.nominations.reduce((sum, n) => sum + (n.quantity || 0), 0)
          event.nominations.forEach((n) => {
            result[n.id] = event.max_submissions - (total - (n.quantity || 0))
          })
        })
      })
      return result
    })

    const quantityOverrides = ref({})
    const quantityUpdatingIds = ref([])

    async function handleQuantityChange(nomId, quantity) {
      quantityUpdatingIds.value = quantityUpdatingIds.value.concat(nomId)
      try {
        // keep_original_status: this popup is the secretary's individual Account Detail popup
        // on the Nom Dashboard — per ACA, a quantity increase's new sibling row should inherit
        // this nomination's own status here, unlike the Nominations page (which gets the normal
        // Unprocessed/Waitlist-by-draft-state rule, the default when this flag is omitted).
        const res = await nominationsApi.updateNomination(nomId, { quantity, keep_original_status: true })
        if (props.onChanged != null) props.onChanged()
        alert.showSuccess(res != null && res.data != null ? res.data.message : null)
      } catch (err) {
        const reverted = { ...quantityOverrides.value }
        delete reverted[nomId]
        quantityOverrides.value = reverted
        alert.showError(extractMsg(err, 'Failed to update quantity'))
      } finally {
        quantityUpdatingIds.value = quantityUpdatingIds.value.filter(id => id !== nomId)
      }
      fetch(props.draftId, buildParams())
    }

    function onQuantityChange(nomId, value) {
      let quantity = Number(value)
      if (!Number.isInteger(quantity) || quantity < 1) return
      const max = quantityMaxByNomId.value[nomId]
      if (max != null && quantity > max) quantity = max
      quantityOverrides.value = { ...quantityOverrides.value, [nomId]: quantity }
      handleQuantityChange(nomId, quantity)
    }

    const hasInvoices = computed(() => data.value != null && data.value.invoices != null && data.value.invoices.length > 0)

    const resending = ref(false)

    async function resendInvoice() {
      resending.value = true
      try {
        const res = await invoicesApi.resend(props.draftId, props.userId)
        alert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Invoice queued for resend')
      } catch (err) {
        alert.showError(extractMsg(err, 'Failed to resend invoice'))
      } finally {
        resending.value = false
      }
    }

    function onClose() {
      emit('close')
    }

    function openPdf(url) {
      window.open(url, '_blank')
    }

    const generatingPdfIds = ref(new Set())

    async function generateInvoicePdf(inv) {
      if (generatingPdfIds.value.has(inv.id)) return
      generatingPdfIds.value = new Set([...generatingPdfIds.value, inv.id])
      try {
        const res = await invoicesApi.getPdf(inv.id)
        const url = res.data.data.url
        if (!url) return
        inv.pdf_path = url
        window.open(url, '_blank')
      } catch (_) { // handled by http interceptor
      } finally {
        const next = new Set(generatingPdfIds.value)
        next.delete(inv.id)
        generatingPdfIds.value = next
      }
    }

    return { data, loading, alert, hasInvoices, resending, resendInvoice, columnsForEvent, openMemberId, openEventId, profileRoute, selectedMemberIds, allSelected, someSelected, toggleSelectMember, toggleSelectAll, toggleMember, toggleEvent, onListChange, pendingListChange, confirmPendingListChange, acceptInvoiceWarning: ACCEPT_INVOICE_WARNING, closedDrawWarning: CLOSED_DRAW_WARNING, onDragStart, onDragEnd, onMoveToEvent, onClose, openPdf, generateInvoicePdf, generatingPdfIds, quantityMaxByNomId, quantityOverrides, quantityUpdatingIds, onQuantityChange }
  }
})
</script>

<style scoped>
.nom-detail-popup {
  position: relative;
  min-width: 560px;
}

.nom-detail-popup__overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.6);
  z-index: 5;
}

.nom-detail-popup__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
}

.nom-detail-popup__member {
  margin-bottom: 4px;
}

.nom-detail-popup__member-header {
  padding: 5px 20px 5px 0;
  margin-bottom: 4px;
  width: fit-content;
}

.nom-detail-popup__member-header--toggle {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}

.nom-detail-popup__member-name {
  font-size: 16px;
  font-weight: 600;
  color: #000;
}

.nom-detail-popup__event {
  margin-bottom: 4px;
}

.nom-detail-popup__event-header {
  font-size: 13px;
  font-weight: 600;
  color: #666;
  padding: 5px 20px;
  height: 30px;
  line-height: 21px;
  margin-bottom: 4px;
}

.nom-detail-popup__event-header--toggle {
  cursor: pointer;
  user-select: none;
}

.nom-detail-popup__chevron {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-bottom: 2px solid #000;
  border-right: 2px solid #000;
  transform: rotate(-45deg);
  transform-origin: center center;
  transition: transform 0.3s ease-out;
  flex-shrink: 0;
  margin: 2px 0 0 8px;
}

.nom-detail-popup__chevron--open {
  transform: rotate(45deg);
}

.nom-detail-popup__chevron--sm {
  border-color: #666;
}

.nom-detail-popup__order {
  font-size: 0.8em;
  color: #666;
  width: 100%;
  text-align: center;
}

.nom-detail-popup__horse-name {
  font-weight: 500;
}

.nom-detail-popup__quantity-input {
  max-width: 100px;
}

.nom-detail-popup__invoice-block {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: 36px;
}

.nom-detail-popup__download-link {
  display: flex;
  align-items: center;
  color: var(--primary);
  &:hover {
    color: var(--primary-dark);
  }
  &--disabled {
    opacity: 0.4;
    cursor: pointer;
  }
  &--loading {
    cursor: default;
    pointer-events: none;
  }
}

.nom-detail-popup__btn {
  font-size: 0.9rem;
}

.nom-detail-popup__spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: nom-spin 0.7s linear infinite;
}

@keyframes nom-spin {
  to { transform: rotate(360deg); }
}

.nom-detail-popup__move-link {
  font-size: 0.8rem;
  color: var(--primary);
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: var(--primary-dark);
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Nominations/components/NominationAccountDetailPopup.vue